import { render, staticRenderFns } from "./AdminPanelMegogoPackageSellingHistory.vue?vue&type=template&id=5c57cb42&"
import script from "./AdminPanelMegogoPackageSellingHistory.vue?vue&type=script&lang=js&"
export * from "./AdminPanelMegogoPackageSellingHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelMegogoPackageSellingHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VDataTable,VToolbar,VToolbarTitle})
